import get from 'lodash/get'
import merge from 'lodash/merge'
import reduce from 'lodash/reduce'
import mux from '@expo/mux'
import GatewayStore from './common/GatewayStore'

// Register stores for apps here.
const stores = {
  Form: () => import('./FormApp/FormStore'),
  Configure: () => import('./ConfigureApp/ConfigureStore'),
  Listing: () => import('./ListingApp/ListingStore'),
}

// Stores that all apps use
const globalStores = {
  Gateway: GatewayStore
}

/**
 * Figures out which stores are needed by the currently active apps,
 * imports them, and includes them in the state.
 *
 * @param activeAppsOrApp array|string
 * @returns {Promise<object>}
 */
export default async (activeApps = {}) => {
  // Get stores from all active apps. The format is [ appName ]: [ app container id ]
  const getAppStores = reduce(activeApps, (allStores, _, app) => {
    const storesForApp = get(stores, app, false)
    
    // Stores should be a function (that returns the promise for the store module).
    if(!storesForApp || typeof storesForApp !== 'function') {
      console.warn(`No stores registered for app '${ app }'.`)
      return allStores
    }
    
    return merge(allStores, {
      [ app ]: storesForApp() // Kick off the promise.
    })
  }, {})
  
  // Await all imports to finish
  const importedStores = await mux(getAppStores)
  
  // We need to map the imported store to the default export.
  const appStores = reduce(importedStores, (allStores, store, key) => {
    allStores[ key ] = store.default
    return allStores
  }, {})
  
  // And merge with the global stores. Done!
  return merge(globalStores, appStores)
}
